/** Weergavehulp voor tekeninganalyse (NL, geen technische ID-glitches in de UI). */

export function formatTechnischeIdVoorWeergave(raw: string | null | undefined): string {
  if (raw == null || !String(raw).trim()) return '—';
  return String(raw)
    .trim()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\*+/g, '')
    .trim();
}

export function hoeveelheidTekst(
  hint: number | null | undefined,
  estimates: Record<string, number> | null | undefined,
  systemId: string
): string {
  const q = typeof hint === 'number' && hint > 0 ? hint : estimates?.[systemId];
  if (typeof q === 'number' && q > 0) return String(q);
  return 'onbekend';
}

export function betrouwbaarheidAlsNlTekst(confidence: number): {
  kop: string;
  uitleg: string;
} {
  const c = Math.max(0, Math.min(1, confidence));
  if (c >= 0.78) {
    return {
      kop: 'Ruwe inschatting: overwegend betrouwbaar',
      uitleg:
        'Het model herkent veel details op de tekening. Dit is geen meetrapport en geen offerte: controleer altijd zelf op de bron en op tab Posten.',
    };
  }
  if (c >= 0.55) {
    return {
      kop: 'Ruwe inschatting: gemengd',
      uitleg:
        'Er zijn aannames gemaakt of onderdelen waren minder duidelijk. Gebruik dit als startpunt en vul aan met eigen gegevens of de assistent.',
    };
  }
  return {
    kop: 'Ruwe inschatting: onzeker',
    uitleg:
      'De tekening of context was beperkt leesbaar, of het model twijfelt. Voeg duidelijkere plannen toe of stel gerichte vragen via de assistent.',
  };
}
